import React from "react";
import Skeleton from "@mui/material/Skeleton";

import styles from "./sharedCartReviewSkeleton.module.scss";

const sk = (props: any) => <Skeleton animation="wave" variant="rectangular" {...props} />;

/**
 * Full-page review skeleton shown while a shared cart (?sharedCartId=) is being
 * loaded — App renders this whenever `sharedCartLoading` is true. Mirrors the
 * flights+hotels review layout (a flight card, a stays card, and the price
 * sidebar) so the recipient lands on a review-shaped loading state. Once the
 * snapshot is reconstructed into the cart, App swaps to the real review page.
 */
function ReviewCardSkeleton({ title }: { title: string }) {
  return (
    <div className={styles.card}>
      <div className={styles.cardHeader}>
        {sk({ width: 24, height: 24, sx: { borderRadius: "6px" } })}
        <span className={styles.cardTitle}>{title}</span>
      </div>
      {sk({ width: "100%", height: 96, sx: { borderRadius: "8px" } })}
      <div className={styles.row}>
        {sk({ width: "40%", height: 14, sx: { borderRadius: "4px" } })}
        {sk({ width: "20%", height: 14, sx: { borderRadius: "4px" } })}
      </div>
      {sk({ width: "60%", height: 14, sx: { borderRadius: "4px" } })}
    </div>
  );
}

export default function SharedCartReviewSkeleton() {
  return (
    <div className={styles.page}>
      <div className={styles.content}>
        <ReviewCardSkeleton title="Flights" />
        <ReviewCardSkeleton title="Stays" />
      </div>
      <aside className={styles.sidebar}>
        <div className={styles.stepper}>
          {sk({ width: 24, height: 24, sx: { borderRadius: "50%" } })}
          {sk({ width: 24, height: 24, sx: { borderRadius: "50%" } })}
          {sk({ width: 24, height: 24, sx: { borderRadius: "50%" } })}
        </div>
        {sk({ width: "70%", height: 16, sx: { borderRadius: "4px", marginTop: "16px" } })}
        <div className={styles.priceRow}>
          {sk({ width: "45%", height: 18, sx: { borderRadius: "4px" } })}
          {sk({ width: "25%", height: 18, sx: { borderRadius: "4px" } })}
        </div>
        <div className={styles.priceRow}>
          {sk({ width: "30%", height: 22, sx: { borderRadius: "4px" } })}
          {sk({ width: "30%", height: 22, sx: { borderRadius: "4px" } })}
        </div>
        {sk({ width: "100%", height: 48, sx: { borderRadius: "24px", marginTop: "20px" } })}
      </aside>
    </div>
  );
}
